import { WrappedData } from './wrapped';

export const MOCK_WRAPPED_DATA: WrappedData = {
  userId: 12345,
  walletAddress: 'Dy8...3xP',
  joinDate: '2024-10-28T12:00:00Z',
  daysSinceJoin: 65,
  platformAgeAtJoin: 0,
  
  // Activity
  tokensJunked: 15420,
  nftsJunked: 42,
  totalItemsJunked: 15462,
  itemsPerDay: 237,
  chestsOpened: 158,
  
  // Financial
  solReclaimed: '4500000000', // 4.5 SOL
  averageSolPerJunk: '290000',
  biggestSingleReclaim: '150000000', // 0.15 SOL
  
  // Seasonal
  seasonsParticipated: 4,
  totalSeasons: 5,
  seasonDetails: [
    { seasonNo: 1, rank: 42, points: '15000', status: 'top_performer' },
    { seasonNo: 2, rank: 156, points: '8000', status: 'participant' },
    { seasonNo: 3, rank: null, points: '0', status: 'skipped' },
    { seasonNo: 4, rank: 12, points: '45000', status: 'rising_star' },
    { seasonNo: 5, rank: 5, points: '62000', status: 'top_performer' },
  ],
  highestSeasonRank: { seasonNo: 5, rank: 5 },
  
  // Points & Lottery
  lifetimePoints: '1250000',
  pointsContributedToLottery: '500000',
  luckyDrawWins: [
    { seasonNo: 2, prizeLabel: 'Small Pot', amountLamports: '100000000' },
    { seasonNo: 5, prizeLabel: 'Jackpot Share', amountLamports: '2500000000' },
  ],
  
  // Streaks
  daysActive: 58,
  longestStreak: 21,
  streakDates: { start: '2024-11-01', end: '2024-11-22' },
  bestDay: { date: '2024-12-15', itemsJunked: 850, chestsOpened: 12 },
  
  // Community
  overallRank: 42,
  totalUsers: 15420,
  percentile: 99.7,
  
  // Badges & Personality
  badges: ['day_one_degen', 'seasonal_whale'],
  personalityType: 'seasonal_whale',
  personalityTraits: ['Competitive', 'High Volume', 'Strategic'],
  
  // NFTs
  nftsMinted: [
    { seasonNo: 1, tier: 'gold', mintAddress: '...' },
    { seasonNo: 4, tier: 'diamond', mintAddress: '...' },
  ],
  
  // Rewards
  viewPointsAwarded: false,
  sharePointsAwarded: false,
};

